import { useContext } from "react";
import AssetsContext from "hooks/AssetsProvider/AssetsContext";

const useAssets = () => {
  return useContext(AssetsContext);
};

export default useAssets;
